import { useNavigate } from 'react-router-dom'

import { ScreenWrapper } from '@/components/templates/ScreenWrapper.tsx'
import { Success } from '@/components/templates/Success.tsx'
import { useTrackFormProgress } from '@/hooks/useTrackFormProgress.ts'
import { useAppointmentStore } from '@/store.ts'
import { XpertFormStep } from '@/utils/XpertFormSteps.ts'

const SuccessScreen = () => {
  const { resetStore, selectedSlot } = useAppointmentStore()

  const { trackFormInteraction } = useTrackFormProgress(
    XpertFormStep.AppointmentConfirmed,
    {
      complete: true,
    },
  )

  const navigate = useNavigate()

  if (!selectedSlot) {
    resetStore()
    navigate('/')
    return null
  }

  return (
    <ScreenWrapper>
      <Success
        slot={selectedSlot}
        onClose={() => {
          resetStore()
          trackFormInteraction({
            action: 'next',
            formFieldName: 'close',
          })
          window.open('https://www.xpertclinics.nl/', '_self')
        }}
      />
    </ScreenWrapper>
  )
}

export { SuccessScreen }
